import { render, staticRenderFns } from "./GrupoFormulario.vue?vue&type=template&id=3073077e&scoped=true"
import script from "./GrupoFormulario.vue?vue&type=script&lang=js"
export * from "./GrupoFormulario.vue?vue&type=script&lang=js"
import style0 from "./GrupoFormulario.vue?vue&type=style&index=0&id=3073077e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3073077e",
  null
  
)

export default component.exports